import React, {
  Component
} from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import Loading from  '../Loading'
import DrNoteModal from "./DrNote";

class FamilyTableView extends Component {

  constructor(props) {
    super(props);
    this.state = {
      ignoreTX: {},
      note:null,
    }
  }

  hideDrModal=()=>{
    this.setState({note:null})
  }
  trimString = (str, len, addDots) => {
    return (
      (str && str.length > len) ?
      (addDots !== false ?
        str.substring(0, len - 3) :
        str.substring(0, len - 3) + '...') :
      str);
  }
notedLoaded(treatmentList){
    for(let i=0;i<treatmentList.length;i++){
       const keys=Object.keys(treatmentList[i])
      if(keys.includes("grpnote")){
        return true
      }
    }
    return "";
}

  render() {
    const {
      BrokenChildTable,
      selectedPatient,
      selectedPracticeName,
      treatmentPlanCalculation
    } = this.props;

    const {
      aptResult,
      treatmentList,
      commlog,
      treatmentPlan
    } = BrokenChildTable;

    const {note}=this.state
    return (
        <div>
          { note && <DrNoteModal note={note} hideDrModal={this.hideDrModal} selectedPatient={selectedPatient}
            selectedPracticeName={selectedPracticeName} dispatch={this.props.dispatch} />}
      <div className = "BCTable wd100" >
        <div className = "row" >
          <div className = "col-xl-5 col-lg-12" >
            <div className = "card pd0 mb20 minHeight360" >
              <div className = "card-header" >
                <h3 className = "headingSub" > Patient Appointment List </h3>
              </div>
              <div className = "card-content" >
                <div className = "scroller" >
                  <table className="table tableCustomStyle"><thead><tr><th>PatNum</th><th>AptDateTime</th><th>APT_Status</th><th>Note</th></tr></thead>
                    {
                      (aptResult && aptResult.length) ?
                        <tbody>
                          { aptResult.map( (item,key) =>
                            <tr key={key}>
                              <td>{item.PatNum}</td>
                              <td>{ item.AptDateTime ? item.AptDateTime : '' }</td>
                              <td>{item.APT_Status}</td>
                              <td>
                                { item.Note ?
                                    <div>
                                      <a className="primaryColor" data-tip data-for={`aptResult${key}`}>
                                        {this.trimString(item.Note, 15, false)}
                                      </a>
                                      <ReactTooltip id={`aptResult${key}`} place="right" type="light" effect="float" border={true}>
                                        {item.Note}
                                      </ReactTooltip>
                                    </div> : ''}
                              </td>
                            </tr>)
                          }
                        </tbody>
                      :
                        (!aptResult ?
                          <tbody><tr key='totalTr'><td colSpan="4"><Loading /></td></tr></tbody>
                        :
                          <tbody><tr key='totalTr'><td colSpan="4">No Record found.</td></tr></tbody>)
                    }
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div className ="col-xl-7 col-lg-12">
            <div className = "card pd0 mb20 minHeight360" >
              <div className = "card-header">
                <h3 className = "headingSub" > Patient Treatment List </h3>
              </div>
              <div className = "card-content">
                <div className = "scroller">
                  <table className="table tableCustomStyle"><thead><tr><th>PatNum</th><th>ProcDate</th><th>Production</th><th>Procedures <br /> Code Category</th><th>Dr. Note</th></tr></thead>
                    {
                      (treatmentList && treatmentList.length) ?
                         !this.notedLoaded(treatmentList)?
                              <tbody><tr key='totalTr'><td colSpan="4"><Loading /> </td></tr></tbody>
                              :
                        <tbody>
                          { treatmentList.map( (item,key) =>
                            <tr key={key}>
                              <td>{item.PatNum}</td>
                              <td>{ item.ProcDate ? item.ProcDate : '' }</td>
                              <td>{(item.Production)?parseFloat(item.Production).toFixed('2'):item.Production}</td>
                              <td>
                                { item.Proc_Category ?
                                    <div>
                                      <a className="primaryColor" data-tip data-for={`Procedures${key}`}>
                                        {this.trimString(item.Proc_Category, 15, false)}
                                      </a>
                                      <ReactTooltip id={`Procedures${key}`} place="right" type="light" effect="float" border={true}>
                                        {item.Proc_Category}
                                      </ReactTooltip>
                                    </div> : ''
                                  }
                              </td>
                              <td className="primaryColor cursorPointer">
                                {
                                  item.grpnote ?
                                      <span onClick={ () => this.setState({note:item.grpnote}) }>
                                      {this.trimString(item.grpnote, 15, false)}
                                    </span>
                                      : ''
                                  }
                              </td>
                            </tr>
                          )}
                        </tbody>
                      :
                        (!treatmentList ?
                          <tbody><tr key='totalTr'><td colSpan="4"><Loading /> </td></tr></tbody>
                        :
                          <tbody><tr key='totalTr'><td colSpan="4">No Record found.</td></tr></tbody>)
                    }
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className = "row">
          <div className = "col-xl-5 col-lg-12">
            <div className = "card pd0 mb20 minHeight360">
              <div className = "card-header">
                <h3 className = "headingSub"> CommLog History </h3>
              </div>
              <div className = "card-content">
                <div className = "scroller">
                  <table className="table tableCustomStyle"><thead><tr><th>PatNum</th><th>CommDateTime</th><th>CommType</th><th>Note</th></tr></thead>
                  {
                    (commlog && commlog.length) ?
                      <tbody>
                        { commlog.map( (item,key) =>
                          <tr key={key}>
                            <td>{item.PatNum}</td>
                            <td>{ item.CommDateTime ? item.CommDateTime : '' }</td>
                            <td>{item.CommType}</td>
                            <td>
                              { item.Note ?
                                  <div>
                                    <a className="primaryColor" data-tip data-for={`commlog${key}`}>
                                      {this.trimString(item.Note, 15, false)}
                                    </a>
                                    <ReactTooltip id={`commlog${key}`} place="right" type="light" effect="float" border={true}>
                                      {item.Note}
                                    </ReactTooltip>
                                  </div> : ''}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    :
                      (!commlog ?
                        <tbody><tr key='totalTr'><td colSpan="4"><Loading /></td></tr></tbody>
                      :
                      <tbody><tr key='totalTr'><td colSpan="4">No Record found.</td></tr></tbody>)
                  }
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div className = "col-xl-7 col-lg-12">
            <div className = "card pd0 minHeight360">
              <div className = "card-header" >
                <h3 className = "headingSub" > Open Treatment Plan </h3>
              </div>
              <div className = "card-content" >
                <div className = "scroller" >
                <table className="table tableCustomStyle">
                <thead><tr><th>PatNum</th><th>ProcDate</th><th>ProcNum</th><th>ToothNum</th><th>ProcCode</th><th>ProcFee</th><th>PC_cat</th></tr></thead>

                {
                  (BrokenChildTable.treatmentPlan && Object.keys(BrokenChildTable.treatmentPlan).length &&
                  treatmentPlan[selectedPatient.PT_Num]) ?
                    <tbody>
                      { treatmentPlan[selectedPatient.PT_Num].map( (item,key) =>
                        <tr key={key}>
                          <td>{item.PatNum}</td>
                          <td>{ item.ProcDate ? item.ProcDate : '' }</td>
                          <td>{item.ProcNum}</td>
                          <td>{item.ToothNum}</td>
                          <td>{item.ProcCode}</td>
                          <td>{item.ProcFee}</td>
                          <td>{item.PC_cat}</td>
                        </tr>
                        )}
                        {<tr key='totalTr'>
                          <td colSpan="4" style={ {textAlign:'right'} }>Total: </td>
                            <td><strong>{(treatmentPlanCalculation.txPlanTotal)?parseFloat(treatmentPlanCalculation.txPlanTotal).toFixed(2):treatmentPlanCalculation.txPlanTotal}</strong></td>
                          <td colSpan="2"></td>
                        </tr>}
                    </tbody>
                  :
                    <tbody><tr key='totalTr'><td colSpan="7">No Record found.</td></tr></tbody> }
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
        </div>
    )

  }
}

export default FamilyTableView;
